import { render, staticRenderFns } from "./NewOrderAlert.vue?vue&type=template&id=245cf148&scoped=true&"
import script from "./NewOrderAlert.vue?vue&type=script&lang=js&"
export * from "./NewOrderAlert.vue?vue&type=script&lang=js&"
import style0 from "./NewOrderAlert.vue?vue&type=style&index=0&id=245cf148&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245cf148",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VIcon,VImg})
